import cx from "classnames";
import React from "react";
import { Table } from "reactstrap";

import { Dispatch, TableBlock } from "../../types";
import { TableCell as TableCellComponent } from "./TableCell";

type Props = Readonly<{
  block: TableBlock;
  active: boolean;
  disabled: boolean;
  selectedCellId: string;
  dispatch: Dispatch;
}>;

const TableCell = React.memo(TableCellComponent);

export const TableEditor = ({ block, disabled, dispatch, selectedCellId, active }: Props) => {
  const editorClass = cx("editor", "table", {
    disabled,
  }, active);

  let minHeight = 0;
  if (active && block.cells.flatMap((x, j) => x).find((c, j) => c.id === selectedCellId)) {
    minHeight = 120;
  }

  return (
    <div className={editorClass} style={{minHeight: minHeight}}>
      <Table>
        <tbody>
          {block.cells.map((r, i) => {
            return (
            <tr key={`row-${i}`}>
              {r.map((c, j) => (
                <td colSpan={c.colSpan} key={`cell-${j}`} rowSpan={c.rowSpan}>
                  <TableCell blockId={block.id} cell={c} dispatch={dispatch} active={active && selectedCellId === c.id}/>
                </td>
              ))}
            </tr>
          )}
          )}
        </tbody>
      </Table>
    </div>
  );
};
TableEditor.displayName = "TableEditor";
